import { useRef, useEffect, useState } from 'react';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';

export const useVote = () => {
  const { user, requestInterval } = useGetParams();

  const currentStateRef = useRef(null);
  const isVisibleRef = useRef(null);
  const [voteState, setVoteState] = useState(null);

  const idRef = useRef(null);

  const protocol = window?.location?.protocol || 'https:';

  const getVoteInfo = async () => {
    try {
      const response = await fetch(
        `${protocol}//stream.iactive.pro/scr/getPollInfo.php?user=${user}`,
        { cache: 'no-store' },
      );
      const data = await response.json();
      if (!data) return;

      let { visibility, activity, id } = data;

      idRef.current = id;

      // Определяем видимость титра
      const isVisible = Boolean(Number(visibility));

      if (!isVisible && isVisible !== isVisibleRef.current) {
        isVisibleRef.current = false;
      } else if (isVisible && isVisible !== isVisibleRef.current) {
        isVisibleRef.current = true;
      }
      // Определяем состояние (S1, S2 ...)

      if (
        data?.state &&
        getActiveState(data?.state) !== currentStateRef.current
      ) {
        currentStateRef.current = getActiveState(data?.state);
      }
      setVoteState(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getVoteInfo();
  }, []);

  useInterval(() => {
    getVoteInfo();
  }, requestInterval);

  return {
    currentState: currentStateRef.current,
    isVisible: isVisibleRef.current,
    voteState,
    idVote: idRef.current,
  };
};
